// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hootsuite-image-uploader {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 20px;
  border: 2px solid #E8ECEF;
  border-radius: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Components/UploadImageHootSuite/UploadImageHootSuite.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AACF","sourcesContent":[".hootsuite-image-uploader {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  padding: 20px;\n  border: 2px solid #E8ECEF;\n  border-radius: 20px;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
